import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class EinspeisungBiogas extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    einspeisung: number | null = null;
    unternehmen: string | null = null;
    ort: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'EinspeisungBiogas';
    }
}

export async function createNewEinspeisungBiogas(): Promise<EinspeisungBiogas> {
    const model = createModel(EinspeisungBiogas, {});

    await model.save();
    return model;
}

export class EinspeisungBiogasCollection extends BaseCollection<EinspeisungBiogas> {
    protected modelCls = EinspeisungBiogas;

    public getModelClassName(): string {
        return 'EinspeisungBiogas';
    }
}
